import React from 'react';
import Filter from '../Filter/Filter';

function FilterAdapter(props) {
  return (
    <Filter
      configuration={props.settings.Configuration}
      query={props.query}
      onQueryChanged={props.onQueryChanged}
      isFetching={props.isFetching}
    />
  );
}

export default FilterAdapter;
